
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'paymentapplicationtskIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'paymentapplicationtsk',
				windowName: '退收款单',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
